import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onSubmitTicket, onStartChat }) => {
  return (
    <div className="mb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Submit Ticket */}
        <div className="bg-gradient-to-br from-blue-500/10 to-blue-600/5 border border-blue-500/20 rounded-lg p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={24} className="text-blue-500" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                Submit a Support Ticket
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                Get help from our support team. We typically respond within 24 hours.
              </p>
              <Button
                variant="default"
                size="sm"
                iconName="Send"
                iconPosition="left"
                onClick={onSubmitTicket}
              >
                Create Ticket
              </Button>
            </div>
          </div>
        </div>

        {/* Live Chat */}
        <div className="bg-gradient-to-br from-green-500/10 to-green-600/5 border border-green-500/20 rounded-lg p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-green-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="MessageCircle" size={24} className="text-green-500" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-heading font-semibold text-foreground">
                  Live Chat Support
                </h3>
                <span className="flex items-center gap-1 px-2 py-0.5 bg-green-500/20 text-green-500 rounded-full text-xs font-medium">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" />
                  Online
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Chat with our support team in real-time. Average response time: 2 minutes.
              </p>
              <Button
                variant="default"
                size="sm"
                iconName="MessageSquare"
                iconPosition="left"
                onClick={onStartChat}
              >
                Start Chat
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;